/**
 * Retrieves a valid image from an image object based on the specified size.
 *
 * @param imgObject - The image object containing different size variations
 * @param size - The desired image size ('original', '128', or '330')
 * @returns The URL of the image in the specified size, or the first available image, or null if no image exists
 */

export const getValidImage = (
  imgObject: img,
  size: 'original' | '128' | '330',
) => {
  if (!imgObject) return null;

  if (size === 'original' && imgObject.image) {
    return imgObject.image;
  }
  if (size === '128' && imgObject.image_128) {
    return imgObject.image_128;
  }
  if (size === '330' && imgObject.image_330) {
    return imgObject.image_330;
  }

  // Return first available image
  if (imgObject.image) return imgObject.image;
  if (imgObject.image_330) return imgObject.image_330;
  if (imgObject.image_128) return imgObject.image_128;

  return null;
};
